export default "/images/vendor/flag-icons/flags/4x3/lc.svg?26619234555a923eb7b3df733548982f";